import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare global {
  interface Window {
    uetq: any[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class BingTrackingService {
  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  trackEvent(
      category: string = 'form',
      transactionId?: string
  ): void {
    if (!this.isBrowser) return;

    window.uetq = window.uetq || [];

    const payload: any = {};
    if (category) payload.event_category = category;
    if (transactionId) payload.transaction_id = transactionId;

    window.uetq.push('event', 'submit_lead_form', payload);
  }
}
